import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function ReferralClaimer() {
  const { user } = useAuth();
  const attempted = useRef(false);

  useEffect(() => {
    if (!user || attempted.current) return;
    const code = localStorage.getItem("cardark_ref");
    if (!code) return;
    attempted.current = true;
    localStorage.removeItem("cardark_ref");
    api
      .post("/referral/claim", { code })
      .then((res) =>
        toast.success(`Invite applied — +${res.data.credits_added} bonus credits for you and your friend!`)
      )
      .catch((e) => {
        const detail = e.response?.data?.detail;
        if (detail) toast.info(`Invite link not applied: ${detail}`);
      });
  }, [user]);

  return null;
}
